import { Component, OnInit, ViewChild, Inject } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { Operator } from "src/_models/operators";
import { FormControl } from "@angular/forms";

export interface DialogData {
  dataInfo: any;
}
interface DropdownOption {
  label: string;
  value: string;
}

@Component({
  selector: "app-user-audit",
  templateUrl: "./useraudit.component.html",
  styleUrls: ["./useraudit.component.scss"],
})
export class UserAuditComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  datalistDisplayedColumns: string[] = ["time", "user_name", "operation", "ip"];
  selected: any = { startDate: new Date().setHours(0, 0, 0, 0), endDate: new Date().setHours(23, 59, 59) * 1000 };
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  datalist = new MatTableDataSource<any>();
  filterUsers = [];
  selectedUser: Operator;
  userName;
  operation = new FormControl([]);
  ip;
  dropdownOptions: DropdownOption[] = [];
  dropdownSettings: any = {};
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(private appService: AppService, public dialog: MatDialog) {}

  ngOnInit() {
    this.getReportData();
    this.initializeDropdownOptions();
    this.dropdownSettings = {
      singleSelection: true,
      idField: "value",
      textField: "label",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  initializeDropdownOptions() {
    try {
      this.appService.getUserOperations().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dropdownOptions = res.userOperations.map((operation: string) => {
            const opSplit = operation.split('/');
            const lastPart = opSplit[opSplit.length - 1];
            const label = lastPart.replace(/-/g, ' ');
            return {
              label: label,
              value: operation
            };
          });
          this.dropdownOptions = [{label: "All",
            value: ""}].concat(this.dropdownOptions)
        }
      });
    } catch (err) {}
  }

  getDate = (date: number) => {
    return moment(date).format("DD MMM YYYY hh:mm A");
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  onChangeUserName(value){
    this.userName=value;
  }
  onChangeIp(value){
    this.ip=value;
  }
  onChangeOperation(value){
    this.operation=value;
  }

  getReportData = () => {
    console.log("value",this.operation.value[0])
    try {
      let filters = {
        user_name: this.userName ? this.userName : null,
        start_time:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        end_time:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
        operation: this.operation.value.length === 0 ? null : this.operation.value[0].value,
        ip: this.ip ? this.ip : null,
      };

      this.appService.getUserAuditData(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist = new MatTableDataSource<any>(res.user_audit_report);
          this.datalist.paginator = this.paginator;
        }
      });
    } catch (err) {}
  };

  openDialog(Details: any) {
    this.dialog.open(UserAuditModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        dataInfo: Details,
      },
    });
  }

  onUserSelection(user: any) {
    this.selectedUser = user;
    this.getReportData();
  }

  onUserSelectionClear() {
    this.selectedUser = null;
    this.getReportData();
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./user_audit_modal.component.html",
  styleUrls: ["./useraudit.component.scss"],
})
export class UserAuditModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    console.log("bbb", data);
  }
}
